<template>
  <b-card>
    <b-row>
      <b-col
        md="12"
        class="mb-2 d-flex justify-content-between align-items-center"
      >
        <h5 class="mb-0">
          Historial de pagos
        </h5>
        <b-button
          variant="outline-secondary"
          size="sm"
          @click="query"
        >
          <feather-icon
            icon="SearchIcon"
            size="18"
            class="mr-50"
          />
          Consultar
        </b-button>
      </b-col>
      <b-col md="12">
        <b-table
          class="position-relative"
          responsive
          show-empty
          :fields="fields"
          :items="items"
          :busy="isBusy"
        >
          <template #table-busy>
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle" />
              <strong>Cargando...</strong>
            </div>
          </template>
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(date)="data">
            {{ data.item.date | dateFormat }}
          </template>
          <template #cell(amount_local)="data">
            {{ business.currencyLabel }}
            {{ data.item.amount_local }}
          </template>
          <template #cell(status)="data">
            <b-badge
              v-if="data.item.status_p2p"
              pill
              :variant="statusVariant(data.item.status)"
            >
              {{ data.item.status_p2p.name }}
            </b-badge>
          </template>
          <!-- AZUL guarda el código de autorización en `authorization` y el id
               de orden en `request_id`; el flujo de PayPal sólo llena
               `request_id`. Con el fallback la columna tiene dato en los dos
               casos. -->
          <template #cell(authorization)="data">
            {{ data.item.authorization || data.item.request_id }}
          </template>
          <!-- Solo los pagos aprobados traen comprobante: el backend no lo
               genera para los pendientes ni los rechazados. -->
          <template #cell(receipt)="data">
            <b-button
              v-if="data.item.receipt"
              variant="flat-primary"
              size="sm"
              @click="openReceipt(data.item.receipt)"
            >
              <feather-icon
                icon="FileTextIcon"
                size="16"
              />
              <span
                class="d-none d-md-inline ml-50"
              >Comprobante</span>
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <b-modal
      id="modal-receipt"
      ref="modal-receipt"
      title="Comprobante de pago"
      centered
      ok-only
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      size="sm"
    >
      <payment-receipt
        v-if="selectedReceipt"
        :receipt="selectedReceipt"
      />
    </b-modal>
  </b-card>
</template>

<script>
import {
  BBadge,
  BButton,
  BCard,
  BCol,
  BModal,
  BRow,
  BSpinner,
  BTable,
} from "bootstrap-vue"
import business from "@/business"
import PaymentReceipt from "@/components/PaymentReceipt.vue"

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BTable,
    BButton,
    BBadge,
    BSpinner,
    BModal,
    PaymentReceipt,
  },
  filters: {
    // `payments.date` es una columna `date` sin cast en el modelo, así que llega
    // como "YYYY-MM-DD". El `split("T")` es por si algún día se le agrega un
    // cast y empieza a llegar en ISO con hora: sin eso el reverse armaría una
    // fecha absurda en vez de fallar visiblemente.
    dateFormat(value) {
      if (!value) return ""

      return String(value).split("T")[0].split("-").reverse().join("/")
    },
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("userData")),
      business,
      isBusy: false,
      items: [],
      // Fecha, Balance y Estado salían vacías porque leían los nombres viejos
      // de las columnas: la tabla `payments` es `date` / `amount_local`, y el
      // catálogo `p2p_statuses` expone `name` (no `estado`). Mismo caso que los
      // renombres ya arreglados en contract-equipment y contract-account-status.
      selectedReceipt: null,
      fields: [
        { key: "index", label: "No." },
        { key: "date", label: "Fecha" },
        { key: "amount_local", label: "Monto", class: "text-right" },
        { key: "status", label: "Estado" },
        { key: "message", label: "Mensaje" },
        { key: "authorization", label: "Autorización" },
        { key: "receipt", label: "", class: "text-right" },
      ],
    }
  },
  created() {
    this.query()
  },
  methods: {
    openReceipt(receipt) {
      this.selectedReceipt = receipt
      this.$refs["modal-receipt"].show()
    },
    // `p2p_statuses` no tiene columna `class` (la variante que leía el badge era
    // siempre vacía), así que el color se deriva del estado.
    statusVariant(status) {
      const variants = {
        A: "success",
        P: "warning",
        I: "danger",
        C: "secondary",
      }

      return variants[status] || "secondary"
    },
    query() {
      this.isBusy = true
      this.$http
        .get("/payment", {
          params: {
            idusuario: this.userData.id,
            status: "NOT-PENDING",
          },
        })
        .then((response) => {
          this.isBusy = false
          this.items = response.data.data
        })
        .catch((error) => {
          this.isBusy = false
          console.log(error)
        })
    },
  },
}
</script>
